import { ENUM__html_ref_stub } from '@/enums/ENUM__html_ref_stub';
import { use_ref_with_fallback } from '@/hooks/_base/use_ref_with_fallback';
import * as SliderPrimitive from '@radix-ui/react-slider';
import { assert_equal } from '@shared/asserts/utils_asserts';
import { DTO__number_range } from '@shared/dto/generation/settings/DTO__number_range';
import * as React from 'react';

interface Props {
  disabled: boolean;
  //
  value_used?: number;
  value_range: number[];
  //
  min: number;
  max: number;

  is_left?: boolean;
}

export const UI_PRIMITIVE__slider_range_thumb = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Thumb>,
  React.ComponentPropsWithoutRef<typeof SliderPrimitive.Thumb> & Props
>(({ disabled, value_range, value_used, min, max, is_left = false, ...props }, ref) => {
  assert_equal(value_range.length, 2);

  /*
   * STATE
   */
  const are_values_equal = value_range.are_first_two_values_equal();

  const ref_thumb = use_ref_with_fallback(ENUM__html_ref_stub.DIV);

  const value = is_left ? value_range[0] : value_range[1];
  const percent = React.useMemo(() => get_percent(), [value, min, max]);

  const [grabbing, set_grabbing] = React.useState(false);

  /*
   * METHODS
   */

  function get_percent() {
    let range = new DTO__number_range(min, max);

    if (!range.is_number_is_in_range(value)) return NaN;

    return range.value_to_percentage(value);
  }

  /*
   * HTML
   */

  return (
    <SliderPrimitive.Thumb
      onPointerDown={() => set_grabbing(true)}
      onPointerUp={() => set_grabbing(false)}
      ref={ref_thumb}
      {...props}
      style={{ left: is_left ? `calc(${percent}% - ${ref_thumb.current.clientWidth}px)` : `calc(${percent}% }px)` }}
      className={`ui-primitive-slider-thumb-range
                  absolute -translate-y-1/2
                  ${disabled ? '' : 'cursor-grab'}  
                  ${grabbing ? '!cursor-grabbing' : ''}
                  flex flex-center 
                  min-w-8 min-h-4  
                  text-xs text-component-item-foreground
                  border border-component-item-border
                  ${value_used === value ? 'border-dashed' : ''}
                  bg-bar
                  transition duration-200 hover-animation
                  focus-visible:outline-none 
                  disabled:pointer-events-none disabled:opacity-50 
                  ${are_values_equal ? `border-r-[0.5px] border-component-item` : ''} 
                  ${is_left ? 'rounded-l-lg' : 'rounded-r-lg'}
        `}
    >
      {value}
    </SliderPrimitive.Thumb>
  );
});
